import { registerFlow } from '../../core/flow-register';
import { routeTo, putOnPath, finish } from '../../core/actions';
import FlowHeader from '../../components/FlowHeader/FlowHeader';
import FooterSite from '../../components/FooterSite/FooterSite';
import BaseLayout from '../../components/BaseLayout/BaseLayout';
import { isValidEmail } from '../shared/testers';
import RJEmailSearchScreen from '../../screens/RJEmailSearchScreen/RJEmailSearchScreen';
import WelcomeScreen from '../../screens/WelcomeScreen/WelcomeScreen';
import RJUnsubscribeScreen from '../../screens/RJUnsubscribeScreen/RJUnsubscribeScreen';

import {
  commitProfileEmail,
  putUserOnPath,
  loadProfileIDs,
  updateAnalytics,
  loadUnsubscribe
} from './loaders';
import { FlowNode } from '../../core/types/flow';
import { contactTextFn } from '../shared/utils';
import { loadUser } from '../shared/loaders';

/**
 * validation all get tested on click
 * but on type only ones matching field name get tested
 */
const nodes: Array<FlowNode> = [
  {
    route: 'email-search',
    screen: RJEmailSearchScreen,
    load: loadUser,
    form: [
      {
        name: 'primaryEmailAddress',
        required: true,
        validation: isValidEmail
      }
    ],
    commit: commitProfileEmail,
    next: {
      default: routeTo('welcome')
    },
    flowProps: {
      analytics: {
        pageName: 'Email'
      }
    }
  },
  {
    route: 'welcome',
    screen: WelcomeScreen,
    load: loadProfileIDs,
    commit: putUserOnPath,
    next: {
      default: putOnPath()
    },
    flowProps: {
      layoutClass: 'medium',
      analytics: {
        pageName: 'Welcome'
      }
    }
  },
  {
    route: 'unsubscribe',
    screen: RJUnsubscribeScreen,
    load: loadUnsubscribe,
    next: {
      default: finish()
    },
    flowProps: {
      analytics: {
        pageName: 'RJUnsubscribe'
      }
    }
  }
];

export default registerFlow({
  namespace: 'return-journey',
  nodes,
  start: 'email-search',
  pageDecorators: [BaseLayout],
  onLoad: [updateAnalytics],
  flowProps: {
    getContactText: contactTextFn(),
    header: FlowHeader,
    footer: FooterSite
  }
});
